<template>
  <div class="quote-tool-step-content">
    <v-row>
      <v-col v-if="publicRedirect">
        <v-alert icon="mdi-link" prominent text type="info">
          Hang tight...
          <v-progress-linear color="primary" indeterminate></v-progress-linear>
        </v-alert>
      </v-col>
      <v-col v-else>
        <v-alert v-if="quote.purchaseService" type="success">
          <template v-if="loading">
            Please wait while we process your order...
          </template>
          <template v-else>
            Thank you for placing your order! You will receive an email shortly
            with the details of your order.
          </template>
        </v-alert>
        <v-alert type="success" v-else>
          <template v-if="loading">
            Please wait while we process your request...
          </template>
          <template v-else>
            Thank you for your request! You will receive an email shortly with
            the details of your quote.
          </template>
        </v-alert>
      </v-col>
    </v-row>
    <template v-if="!loading && !quote.purchaseService">
      <div class="d-flex justify-center align-items-center my-7">
        <v-btn  @click="onCreateNewQuote" outlined color="action" dark>
          Start New Quote
        </v-btn>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapState, createNamespacedHelpers } from "vuex";

const {
  mapActions,
  mapMutations
} = createNamespacedHelpers("quotes");

export default {
  name: "FinishStep",
  props: ["nextStep", "previousStep"],
  computed: {
    ...mapState("quotes", [
      "loading",
      "redirectUrl",
      "isService",
      "preventRedirects",
      "quote"
    ]),
    ...mapState({
      cStep: state => state.currentStep
    }),
    currentStep: {
      get() {
        return this.cStep;
      },
      set(value) {
        this.SET_STEP(value);
      }
    },
    ...mapGetters("quotes", ["userAccess"]),
    isLive(){
      return window.location.href.includes("nextdaystaging") ||
          window.location.href.includes("nextdaydumpsters")
    },
    publicRedirect() {
      return this.quote.purchaseService &&
        !this.loading &&
        this.isLive
        ? "/order-confirmation"
        : false;
    },
    
  },
  watch: {
    redirectUrl(val) {
      const result = val
      if (result != false && this.publicRedirect && !this.preventRedirects) {
        setTimeout(()=> {
          this.$router.push(result);
        }, 2000);
      }
    },
    publicRedirect(val) {
      const result = val
      if (result != false) {
        setTimeout(()=> {
          window.location.href = this.publicRedirectUrl;
        }, 2000);  
      }
    }
  },
  async mounted() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    if (await this.publicRedirect !== false) {
      setTimeout(()=> {
        window.location.href = this.publicRedirectUrl;
      }, 2000);  
    }
  },
  data() {
    return {
      publicRedirectUrl: 'https://nextdaydumpsters.com/order-confirmation'
    };
  },
  methods:{
    ...mapActions(["reset"]),
    ...mapMutations(["SET_STEP"]),
    async onCreateNewQuote(){
      window.location.reload(true);
    }
  }
};
</script>
